export default {
  name: 'Платформа',
  url: 'Сайт',
  formRec: 'Фриланс-платформа',
  formTab: 'Фриланс-платформы'
};